import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { PersonaContext } from "../context/PersonaContext";
import Header from "../components/Header";

const UploadContactPage = () => {
  const navigate = useNavigate();
  const { resetQuestions } = useContext(PersonaContext);

  return (
    <div className="dataset-page">
      <Header />
      <h2>Upload your own Dataset</h2>
      <p>
        For integrating your dataset with the PRIME persona creator, please
        contact
      </p>
      <ul>
        <li>
          Prof Lynne Baillie (
          <a href="mailto:l.baillie@hw.ac.uk">l.baillie@hw.ac.uk</a>) or
        </li>
        <li>
          Dr Mehdi Rizvi (<a href="mailto:s.rizvi@hw.ac.uk">s.rizvi@hw.ac.uk</a>
          )
        </li>
      </ul>
      <div className="navigation-buttons">
        <button onClick={() => navigate("/")} className="back-button">
          Back
        </button>
      </div>
    </div>
  );
};

export default UploadContactPage;
